// import { Link, useLocation } from "react-router-dom";
import "./Header.scss";

export default function Header() {
  return <></>;
}
